<template>
  <div>
    <!-- 二维码弹窗 -->
    <div class="delete_view">
      <el-dialog
        :title="title"
        :visible.sync="dialogVisibleObj.qrPopup"
        :close-on-click-modal="false"
      >
        <div class="mian">
          <p>
            {{ title == "培训二维码" ? "培训" : "考核" }}名称:
            <span>{{ statePopupstatus.Title }}</span>
          </p>
          <vueqr
            :bgSrc="config.logo"
            :logoSrc="config.imagePath"
            :text="config.value"
            :size="200"
            ref="isAn"
          ></vueqr>
          <p style="color: red">请使用微信扫一扫</p>
          <el-button type="text" size="small" @click="download"
            >下载二维码</el-button
          >
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleObj.qrPopup = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisibleObj.qrPopup = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- canvas生成的图片 -->
    <div v-if="dialogVisibleObj.qrPopup" ref="codeDownLoad" class="delete_view qrcodeView ">
      <p>
        {{ title == "培训二维码" ? "培训" : "考核" }}名称:
        <span>{{ statePopupstatus.Title }}</span>
      </p>
      <vueqr
        :bgSrc="config.logo"
        :logoSrc="config.imagePath"
        :text="config.value"
        :size="300"
      ></vueqr>
      <p style="color: red">请使用微信扫一扫</p>
    </div>
    <div v-if="dialogVisibleObj.qrPopup">
      <img ref="saveImage" src="" alt="" />
    </div>
  </div>
</template>

<script>
import vueqr from "vue-qr";
export default {
  props: ["statePopupstatus", "title"],
  data() {
    return {
      dialogVisibleObj: {
        qrPopup: false,
      },
      qrcodeImg: "", // 二维码的bs64地址
      config: {
        //二维码内的信息
        value:
          "https://stsqapit.tibosi.com/sharewebview?isShare=0&url=zyysbmj&BannerID=2222", //显示的值、跳转的地址
        imagePath: require("../../assets/yunlogo.png"), //中间logo的地址
      },
      sundflag: false, // 结束考试防抖
    };
  },
  components: {
    vueqr,
  },
  methods: {
    // 下载二维码
    download() {
      let qrcodeImg = this.$refs.saveImage.src;
      let image = new Image();
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        let a = document.createElement("a");
        let event = new MouseEvent("click");
        a.download = "myImage";
        a.href = qrcodeImg;
        a.dispatchEvent(event);
      };
      image.src = qrcodeImg;
      // this.qrcodeImg = this.$refs.isAn.$el.src;
      // let image = new Image();
      // image.setAttribute("crossOrigin", "anonymous");
      // let that = this;
      // image.onload = function () {
      //   let a = document.createElement("a");
      //   let event = new MouseEvent("click");
      //   a.download = "myImage";
      //   a.href = that.qrcodeImg;
      //   a.dispatchEvent(event);
      // };
      // image.src = this.qrcodeImg;
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.delete_view {
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep.el-dialog__footer {
    // justify-content: left !important;
  }
  span > button:nth-child(3) {
    margin-left: 50px;
  }
  ::v-deep .el-dialog__footer span > button:nth-child(2) {
    margin-left: 0;
  }
  .mian {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .el-button {
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #0084ea;
    }
    p {
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #272636;
      margin: 0;
      span {
        margin-left: 4px;
      }
    }
  }
  .el-dialog__footer span > button {
    margin-top: 10px;
  }
}
::v-deep .delete_view .el-dialog {
  width: 300px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
    > .el-form-item {
      flex: 1;
      display: flex;
      align-content: center;
      ::v-deep .el-input {
        width: 420px;
      }
      .son_input > input {
        width: 420px;
      }
    }
  }
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  font-size: 24px;
  color: #fff;
}
::v-deep .el-dialog__header {
  height: 55px;
  background: #0084ea;
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 16px;
  letter-spacing: 2px;
  font-family: PingFang SC;
  box-sizing: border-box;
  text-align: center;
  .el-dialog__title {
    color: #fff;
  }
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .el-dialog__footer {
  padding: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: center;
  button {
    width: 80px;
    height: 40px;
    border-radius: 2px;
    color: #fff;
    font-size: 14px;
    &:nth-child(1) {
      background: #c4c4c4;
      margin-right: 10px;
    }
    &:nth-child(2) {
      background: #0084ea;
    }
  }
}
.qrcodeView{
  width: 300px;
  height: 400px;
  background-color: #fff;
  // padding: 24px;
  text-align: center;
  padding-top:22px;
  margin-top: 450px;
}
</style>
